import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export class CubiqBrokerHmrState {
  constructor(private readonly _hmr: boolean = false, private _autoPrime: boolean = false) {
    logger.out.info(`${this.constructor.name}() %O`, this);
  }

  public get autoPrime(): boolean {
    logger.out.info(`${this.constructor.name}.autoPrime %O`, this);
    return this._autoPrime;
  }

  public set autoPrime(value: boolean) {
    logger.out.info(`${this.constructor.name}.autoPrime = ${value} %O`, this);
    this._autoPrime = value;
  }

  public get hmr(): boolean {
    logger.out.info(`${this.constructor.name}.hmr %O`, this);
    return this._hmr;
  }
}
